import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import FrCloseSvg from '@src/svgs/fr-close-small.svg';
import { Save } from '../Save';
import { FooterForModalProps } from './props';
import './styles.scss';

export const FooterForModal: FC<FooterForModalProps> = ({ user, onClose }) => {
  return (
    <div className="pipeline-talent-card-modal-footer">
      {user && <Save user={user} />}

      <div className="pipeline-talent-card-modal-footer__close" onClick={onClose}>
        <Svg className="pipeline-talent-card-modal-footer__close-icon" src={FrCloseSvg} />
        <span>Close</span>
      </div>
    </div>
  );
};
